import styled from 'styled-components';

export const InputSearchWrapper = styled.div`
  input {
    height: 100%;
    padding: 0.7rem 1.5rem;
  }
`;
